<script>
    /* Copyright (c) 2020-2022 Jacques Desodt */
    import {getAmPm, hourToDegrees, minuteToDegrees} from '../scripts/dates.js';

    export let args = {};
    export let date = new Date();
    export let hoursSelected = true;
    export let transitionClass;

    /* Local variables */
    let style;
    $: style = args.bgColor ? 'background-color:' + args.bgColor + ';' : '';
    let ampm;
    $: ampm = hoursSelected ? (args.is24h ? getAmPm(date) : 'am') : 'am';
    let degrees;
    $: degrees = hoursSelected ? hourToDegrees(date) : minuteToDegrees(date);
    let isFiveMinutes;
    $: isFiveMinutes = Math.round(degrees / 30) === (degrees / 30);
    let pointerStyle;
    $: pointerStyle = 'color:' + args.bgColor + ';' +
            (hoursSelected || isFiveMinutes ? 'background-color:' + args.bgColor + ';' : '');
</script>

<div class="_tp-hand _tp-hand-{ampm} {transitionClass}"
     style="transform: rotateZ({90 + degrees}deg);{style}"
>
    <div class="_tp-pointer" style={pointerStyle}></div>
</div>

<style>._tp-hand{bottom:50%;left:calc(50% - 1px);position:absolute;transform-origin:center bottom 0;width:2px}._tp-hand._tp-hasTransition{transition:transform .3s cubic-bezier(.4,0,.2,1) 0ms,height .3s cubic-bezier(.4,0,.2,1) 0ms}._tp-hand-am{height:39.5%}._tp-hand-pm{height:26.5%}._tp-pointer{border:14px solid;border-radius:100%;box-sizing:content-box;height:4px;left:-16px;position:absolute;top:-21px;width:4px}</style>
